import { useState, useCallback } from 'react';

/**
 * Custom hook for managing location pagination state
 * Handles pagination data and page change events
 */
export const useLocationPagination = () => {
	const [paginationData, setPaginationData] = useState({
		paginatedData: [],
		currentPage: 1
	});

	const handlePageChange = useCallback((newPaginationData) => {
		setPaginationData(newPaginationData);
	}, []);

	const { currentPage } = paginationData;

	return {
		paginationData,
		currentPage,
		handlePageChange
	};
};
